import React from 'react';
import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import type { SearchInputProps } from 'app/components';
import { SearchInput } from 'app/components';
import { TranslationKeys } from 'app/translations';
import { CheckboxStyled } from './UsersAccessListHeader.styles';

type UserAccessesListHeaderProps = {
  isLoading: boolean;
  onChange: SearchInputProps['onChange'];
  headerTextId: string;
  onSelectAll: () => void;
  onSelectAllOnPage: () => void;
  areAllSelected?: boolean;
  areAllOnPageSelected?: boolean;
  noData?: boolean;
  disabled?: boolean;
  totalCount?: number;
};

export const UserAccessesListHeader = ({
  onSelectAll,
  onSelectAllOnPage,
  onChange,
  isLoading,
  headerTextId,
  areAllSelected = false,
  areAllOnPageSelected = false,
  disabled = false,
  noData = false,
  totalCount = 0,
}: UserAccessesListHeaderProps) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
        <Typography variant={'h5'} marginLeft={1}>
          <FormattedMessage id={headerTextId} />
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
          <CheckboxStyled
            name={'select-all-on-page'}
            label={<FormattedMessage id={TranslationKeys.global_selectAllOnPage} />}
            checked={areAllOnPageSelected}
            onChange={onSelectAllOnPage}
            disabled={disabled || isLoading || noData}
          />
          <CheckboxStyled
            name={'select-all'}
            label={<FormattedMessage id={TranslationKeys.global_selectAllCount} values={{ count: totalCount }} />}
            checked={areAllSelected}
            onChange={onSelectAll}
            disabled={disabled || isLoading || noData}
          />
        </Box>
      </Box>

      <SearchInput disabled={isLoading} onChange={onChange} />
    </Box>
  );
};
